module.exports = __webpack_public_path__ + "img/ddb2214.png";